import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.CurrencyDenominationEnumSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    currencyDenominationEnumList: { items: data, total },
  } = await sdk.getListCurrencyDenominationEnum(
    filterSortPage({ filter, sort, pagination })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { currencyDenominationEnum: data } =
    await sdk.getOneCurrencyDenominationEnum({
      id,
    });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { currencyDenominationEnumMany: data } =
    await sdk.getManyCurrencyDenominationEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const currencyDenominationEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
